export default "__VITE_ASSET__TuiWG4HZ__"